import { apiUrl } from '../../../api';
import { PRIO } from '../../../constants';

/** Contact classification fetching */
export const FETCH_CONTACT_CLASSIFICATIONS_REQUEST =
  PRIO + 'FETCH_CONTACT_CLASSIFICATIONS_REQUEST';
export const FETCH_CONTACT_CLASSIFICATIONS_COMMIT =
  PRIO + 'FETCH_CONTACT_CLASSIFICATIONS_COMMIT';
export const FETCH_CONTACT_CLASSIFICATIONS_ROLLBACK =
  PRIO + 'FETCH_CONTACT_CLASSIFICATIONS_ROLLBACK';

export const fetchContactClassifications = () => ({
  type: FETCH_CONTACT_CLASSIFICATIONS_REQUEST,
  requiresAuth: true,
  meta: {
    offline: {
      // the network action to execute:
      effect: {
        url: `${apiUrl}/setting/ContactClassification`,
        method: 'GET',
      },
      // action to dispatch when effect succeeds:
      commit: { type: FETCH_CONTACT_CLASSIFICATIONS_COMMIT },
      // action to dispatch if network action fails permanently:
      rollback: {
        type: FETCH_CONTACT_CLASSIFICATIONS_ROLLBACK,
        snackbarErrorMessage: {
          label: 'settings:errorMessages.fetchContactClassificationError',
          timeout: 6,
        },
      },
    },
  },
});
